import React from "react";
import { DynamicRankmiDashboard } from "@rankmi/dashboard-app";
import { organizationDashboardFilters } from "../dashboardFilters";

const CustomDashboard = ({
  idDashboard,
  enterpriseToken,
  organizationDomainToken = null,
}) => {
  const filters = {
    enterprise_token: [enterpriseToken],
    ...organizationDashboardFilters(organizationDomainToken),
  };

  return (
    <div className="SelectionProcessReport">
      <DynamicRankmiDashboard
        dashboard={idDashboard}
        product={"rkm_14"}
        filters={filters}
      />
    </div>
  );
};

export default CustomDashboard;
